import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent, BadgeType } from '@camelot/ui';
import { MissionType } from '@camelot/user';

import { CamTranslationProject } from '../../../../translation.service';

export const missionTypeLabel = (type: MissionType) =>
  `project.planning.mission.type.${MissionType[type]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-mission-type',
  templateUrl: './type.component.html',
  styleUrls: ['./type.component.scss'],
  imports: [TranslatePipe, BadgeComponent],
})
export class MissionTypeComponent {
  type = input.required<MissionType>();

  constructor() {
    CamTranslationProject.getInstance();
  }

  public label() {
    return missionTypeLabel(this.type());
  }

  public badgeType(): BadgeType {
    switch (this.type()) {
      case MissionType.CustomerSupport:
        return 'info';
      case MissionType.Inspection:
        return 'secondary';
      case MissionType.Installation:
        return 'success';
      case MissionType.Maintenance:
        return 'danger';
      case MissionType.ProjectManagement:
        return 'warning';
      case MissionType.Sales:
        return 'primary';
      case MissionType.Technical:
        return 'purple';
      case MissionType.Other:
        return 'orange';
      default:
        return 'info';
    }
  }
}
